import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPinterestIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_5380_98367)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12Z",
			fill: "white"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M6 0C2.68642 0 0 2.68642 0 6C0 8.54321 1.58025 10.716 3.81235 11.5901C3.75802 11.116 3.71358 10.3852 3.8321 9.86667C3.94074 9.39753 4.53333 6.88395 4.53333 6.88395C4.53333 6.88395 4.35556 6.52346 4.35556 5.99506C4.35556 5.16049 4.83951 4.53827 5.44198 4.53827C5.95556 4.53827 6.20247 4.92346 6.20247 5.38272C6.20247 5.8963 5.87654 6.66667 5.7037 7.38272C5.56049 7.98025 6.00494 8.46914 6.59259 8.46914C7.65926 8.46914 8.47901 7.34321 8.47901 5.72346C8.47901 4.28642 7.44691 3.28395 5.97037 3.28395C4.26173 3.28395 3.25926 4.56296 3.25926 5.88642C3.25926 6.4 3.45679 6.95309 3.7037 7.25432C3.75309 7.31358 3.75802 7.3679 3.74321 7.42716C3.69877 7.61481 3.59506 8.02469 3.57531 8.10864C3.55062 8.21728 3.48642 8.24198 3.37284 8.18765C2.62222 7.83704 2.15309 6.74568 2.15309 5.86173C2.15309 3.97037 3.52593 2.2321 6.11852 2.2321C8.19753 2.2321 9.81728 3.71358 9.81728 5.69877C9.81728 7.7679 8.51358 9.4321 6.70617 9.4321C6.09877 9.4321 5.52593 9.11605 5.33333 8.74074C5.33333 8.74074 5.0321 9.88642 4.95802 10.1679C4.82469 10.6914 4.45926 11.3432 4.21235 11.7432C4.77531 11.916 5.3679 12.0099 5.99012 12.0099C9.3037 12.0099 11.9901 9.32346 11.9901 6.00988C12 2.68642 9.31358 0 6 0Z",
			fill: "#E60019"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_5380_98367",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 12,
			height: 12,
			fill: "white"
		})
	}) })]
});
export default SvgPinterestIcon;
